<template>
  <div id="dapin" class="hm_bc">
    <div class="hm_header">
      <div class="left-name">{{ homeconfig.screen_general_title }}</div>
      <div class="center-btn">
        <div class="every-btn" :class="btnNum == 1 ? 'btn-click' : ''" @click="gopath(1)">
          {{ homeconfig.screen_page_one_title }}
        </div>
        <div class="every-btn" :class="btnNum == 2 ? 'btn-click' : ''" @click="gopath(2)">
          {{ homeconfig.screen_page_two_title }}
        </div>
        <div class="every-btn" :class="btnNum == 3 ? 'btn-click' : ''" @click="gopath(3)">
          {{ homeconfig.screen_page_three_title }}
        </div>
        <div v-if="homeconfig.screen_page_three_title" class="every-btn" :class="btnNum == 5 ? 'btn-click' : ''"
          @click="gopath(5)">
          互联共建
        </div>
        <div v-if="homeconfig.other_open == 1 && homeconfig.other_open_name && homeconfig.other_open_address"
          class="every-btn" @click="gopath(6)">
          <div style="    overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">{{ homeconfig.other_open_name
          }}</div>
        </div>
      </div>
      <div class="right-text" @click="gopath(4)">{{ homeconfig.screen_general_right_title }}</div>
    </div>
    <div style="flex: 1; height: 100%; width: 100%">
      <router-view />
    </div>
  </div>
</template>
<script>
import { pageResize } from "@/assets/js/resetScreenSize";
import { gethomepageapi } from "@/network/api/platformghome";
import { isApp } from "../../../../assets/js/baseURL";
export default {
  components: {},
  data() {
    return {
      openWebView: false,
      btnNum: 1,
      homeconfig: {}
    };
  },
  watch: {
    $route(to, from) {
      // console.log(to.meta.setIndex);
      this.btnNum = to.meta.setIndex
    }
  },
  mounted() {
    pageResize();
    this.getconfiginfo();
    this.btnNum = this.$route.meta.setIndex;
    this.initMui()

  },
  methods: {
    gopath(index) {
      if(index!=6){
        this.btnNum = index;
      }
    
      switch (index) {
        case 1:
          this.$router.push({ name: 'Team' })
          break;
        case 2:
          this.$router.push({ name: 'BasicInfo' })
          break;
        case 3:
          this.$router.push({ name: 'Achievement' })
          break;
        case 4:
          this.$router.push({ name: 'Home' })
          break;
        case 5:
          this.$router.push({ name: 'Interconnection' })
          break;
        case 6:
          if (isApp == 0) {
            window.location.href = this.homeconfig.other_open_address
          } else {
            this.toLink(this.homeconfig.other_open_address)
            // this.$router.push({ name: 'Web', query: { open_address: encodeURIComponent(this.homeconfig.other_open_address) } })
          }
          break;
      }
    },
    async getconfiginfo() {
      let datas = await gethomepageapi();
      if (datas.data.res) {
        this.homeconfig = datas.data.res
        console.log(this.homeconfig)
      }
    },
    initMui() {
      let _this = this
      mui.init({
        beforeback: function () {
          if (_this.openWebView) {
            //获得列表界面的webview jmyc
            var viewObj = plus.webview.getWebviewById('jmyc')
            //canBack查询窗口是否可退
            viewObj.canBack((event) => {
              var canBack = event.canBack
              if (canBack) {//如可退，则返回上一页面
                viewObj.back()
              } else {//如不可退，则退出窗口
                plus.webview.close('jmyc')
                _this.openWebView = false
              }
            })
            return false
          }
          return true
        }
      })
    },
    toLink(url) {
      this.openWebView = true
      mui.openWindow({
        url: url,
        id: 'jmyc',
        styles: {                             // 窗口参数 参考5+规范中的WebviewStyle,也就是说WebviewStyle下的参数都可以在此设置
          titleNView: {                       // 窗口的标题栏控件
            autoBackButton: true,             //新打开的窗口是否有返回键
            // // titleText:"标题栏",                // 标题栏文字,当不设置此属性时，默认加载当前页面的标题，并自动更新页面的标题
            // titleColor: '#000000',             // 字体颜色,颜色值格式为"#RRGGBB",默认值为"#000000"
            // titleSize: '17px',                 // 字体大小,默认17px
            // backgroundColor: '#F7F7F7',        // 控件背景颜色,颜色值格式为"#RRGGBB",默认值为"#F7F7F7"
            // progress: {                        // 标题栏控件的进度条样式
            //   color: '#00FF00',                // 进度条颜色,默认值为"#00FF00"
            //   height: '2px'                    // 进度条高度,默认值为"2px"
            // },
            // splitLine: {                       // 标题栏控件的底部分割线，类似borderBottom
            //   color: '#CCCCCC',                // 分割线颜色,默认值为"#CCCCCC"
            //   height: '1px'                    // 分割线高度,默认值为"2px"
            // }
          }
        }
      })
    }
	},
}

</script>
<style lang="less" scoped>
.hm_bc {
  width: 100%;
  height: 100%;
  background-image: url("~@/assets/images/ktscreen/bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
}

.hm_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  min-height: 0.593rem;
  max-height: 0.593rem;
  color: #fff;
  box-sizing: border-box;
  border-bottom: 0.03125rem solid #1a909e;
  position: relative;

  .left-name {
    font-size: 0.312rem;
    color: #fff;
    font-weight: bold;
    // position: absolute;
    top: 0.07rem;
    // left: 0.4;
    margin-left: 0.4rem;
  }

  .center-btn {
    height: 0.46rem;
    // position: absolute;
    bottom: 0rem;
    left: 5.4rem;
    display: flex;
    align-items: center;
    margin-top: 0.12rem;

    .every-btn {
      width: 2.2rem;
      height: 100%;
      background-color: transparent;
      font-size: 0.24rem;
      font-weight: 400;
      color: #1a909e;
      /* text-align: center; */
      cursor: pointer;
      /* line-height: 0.35rem; */
      letter-spacing: 0.05rem;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .btn-click {
      background-color: #1a909e;
      color: #ffffff;
    }
  }

  .right-text {
    font-size: 0.3rem;
    color: #1a909e;
    // position: absolute;
    margin-right: 1.125rem;
    top: 0.07rem;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Works/platformHome/components/screenbox.vue